var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12"},[_c('div',{staticClass:"text-sm-end d-none d-sm-block"},[_vm._v("Powered by "),_c('a',{attrs:{"href":"mosacpublicidad.com"}},[_vm._v("Mosaca Publicidad")]),_vm._v(". ")])])])])])
}]

export { render, staticRenderFns }